/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React, {Component} from 'react';
import { Redirect } from 'react-router';

import {isUserSignedIn, isUserProfileLoaded, getLinkForSignIn, UserContext} from "../UserContext";

import NotFound from "../components/NotFound";
import Loading from "../components/Loading";

import SignInToSharePromoPage from './SignInToSharePromoPage';
import {withRouter} from "react-router-dom";


class NewHelpTicketView extends Component {

    static contextType = UserContext;

    constructor(props) {
            super(props);
            this.state = {
                isLoading: false,
                isFound: false,
                isSaved: false,
                ticketId: null,
            };
    }

    validateRestResponse(response) {
        if (response.status !== 200) {
            throw Error(response.statusText);
        }
        return response;
    }

    catchRestError(response) {
        this.setState({isLoading: false, isFound: false});
    }

    componentDidMount() {
        this.setState({isLoading: true, isFound: true, isSaved: false});

        const url = '/rest/internet/helpme/savenew/'+this.props.match.params.datablob;

        fetch(url)
            .then(response => this.validateRestResponse(response))
            .then(response => {
                return response.json();
            })
            .then(data => {
                this.setState({ticketId: data.ticketId, isLoading: false, isFound: true, isSaved: true});
            })
            .catch(e => this.catchRestError(e))
        ;
    }

    render() {
        const {isLoading, isFound, ticketId} = this.state;

        if (isLoading || !isUserProfileLoaded(this.context)) {
            return <Loading/>
        }

        if (!isUserSignedIn(this.context)) {
            return <SignInToSharePromoPage link={getLinkForSignIn(this.context, window.location.href)} />;
        }

        if (!isFound) {
            return <NotFound/>;
        }

        return (<Redirect to={'/helpme/open/'+ticketId} />);
    }


}

export default withRouter(NewHelpTicketView)